module.exports = __webpack_public_path__ + "img/calculator.58747e6e.jpg";